import * as React from 'react';
import { useContext } from 'react';
import { Button } from '@cian/ui-kit';
import { TButtonSize } from '@cian/ui-kit/button/types/TButtonSize';
import { TButtonTheme } from '@cian/ui-kit/button/types/TButtonTheme';
import { PhonesOpened } from './PhonesOpened';
import { TPlaceType } from '../../types/promoOffersSelection/callButton';
import { preparePhones } from '../../utils/phone';
import { PromoOfferCardContext } from '../../utils/promoOfferCardContext';

interface ICallButtonProps {
  onClick(): void;
  theme?: TButtonTheme;
  size?: TButtonSize;
  placeType: TPlaceType;
}

export const CallButton = ({ onClick, size, theme, placeType }: ICallButtonProps) => {
  const { builder } = useContext(PromoOfferCardContext);

  const formattedPhone = React.useMemo(() => {
    const phones = preparePhones(builder?.phones || []);

    return phones[0];
  }, [builder]);

  const [isPhonesOpened, setPhonesOpened] = React.useState(false);

  const onCallButtonClick = React.useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();

      onClick();
      setPhonesOpened(true);
    },
    [onClick],
  );

  if (!formattedPhone) {
    return null;
  }

  if (!isPhonesOpened) {
    return (
      <Button size={size} theme={theme} onClick={onCallButtonClick} tabIndex={-1}>
        Контакты застройщика
      </Button>
    );
  }

  return <PhonesOpened placeType={placeType} formattedPhone={formattedPhone} />;
};
